
import * as deviceRecordWeiXiu from './deviceRecord'



let a = Object.assign({ },deviceRecordWeiXiu)
export default a
